export const routingActionCreator = (route: string, alternativeRoute?: string) => {
    return {
        type: route,
        payload: {
            openInNewTab: false,
            internal: true
        }
    };
};
